import { FC } from 'react';
import { useTranslation } from 'hooks';
import ModalContent from 'components/modal/components/ModalContent';
import ModalFooter from 'components/modal/components/ModalFooter';
import ModalTitle from 'components/modal/components/ModalTitle';
import Button from 'components/ui/button';
import I18nHelpers from 'i18n/I18nHelpers';
import { ReactComponent as NewMenu } from 'images/menuVersion/new-menu.svg';
import { ReactComponent as OldMenu } from 'images/menuVersion/old-menu.svg';
import './menuVersionNotification.scss';

interface Props {
  callback: (result: boolean) => void;
}

export const MenuVersionNotification: FC<Props> = ({ callback }) => {
  const getTranslate = useTranslation();

  return (
    <>
      <ModalTitle>{getTranslate('menuVersion.notification.title')}</ModalTitle>
      <ModalContent>
        <div className='menu-version-modal'>
          <div className='menu-version-modal__messages'>
            <p className='menu-version-modal__text'>
              {getTranslate('menuVersion.notification.subtitle')}
            </p>
            <ul className='menu-version-modal__notes'>
              <li className='menu-version-modal__note-item'>
                {I18nHelpers.parseString(
                  getTranslate('menuVersion.notification.note1')
                )}
              </li>
              <li className='menu-version-modal__note-item'>
                {I18nHelpers.parseString(
                  getTranslate('menuVersion.notification.note2')
                )}
              </li>
            </ul>
          </div>
          <div className='menu-version-modal__wrapper'>
            <h3 className='menu-version-modal__title'>
              {getTranslate('Before')}
            </h3>
            <h3 className='menu-version-modal__title'>
              {getTranslate('After')}
            </h3>
          </div>
          <div className='menu-version-modal__picture'>
            <OldMenu />
            <NewMenu />
          </div>
        </div>
      </ModalContent>
      <ModalFooter>
        <Button
          text={getTranslate('menuVersion.notification.secondary.button.label')}
          status='outline'
          size='normal'
          customClass='menu-version-modal__action'
          onClick={() => callback(true)}
        />
        <Button
          text={getTranslate('menuVersion.notification.primary.button.label')}
          status='primary'
          size='normal'
          customClass='menu-version-modal__action'
          onClick={() => callback(false)}
        />
      </ModalFooter>
    </>
  );
};
